exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".product-attachments__container{display:flex}.product-attachments-head__breadcrumb{color:#44555d}.product-attachments-head__mobile-breadcrumb{display:flex;color:#44555d}.product-attachments-head__mobile-breadcrumb:active,.product-attachments-head__mobile-breadcrumb:focus,.product-attachments-head__mobile-breadcrumb:hover,.product-attachments-head__mobile-breadcrumb:visited{color:#44555d}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};